document.addEventListener('DOMContentLoaded', function () {
	let swiper;
	// 有効化時のオプションを記述
	function initializeSwiper() {
		swiper = new Swiper('.swiper', {
			loop: true,
			speed: 1500,
			slidesPerView: 1,
			centeredSlides: false,
			// effect: "fade",
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: false,
				dynamicBullets: false,
			},
		});
	}
	// 無効化する用の記述
	function destroySwiper() {
		if (swiper) {
			swiper.destroy();
			swiper = undefined;
		}
	}
	// if分を用いて横幅に応じて関数を実行
	function handleResize() {
		var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (w < 769) {
			if (!swiper) {
				initializeSwiper();
			}
		} else {
			destroySwiper();
		}
	}
	// 初回実行
	handleResize();
	window.addEventListener('resize', handleResize);
});
